import {combineReducers} from 'redux'
import { persistReducer } from 'redux-persist';
import localforage from 'localforage';
import locationReducer from './features/location/slice'
import mapReducer from './features/map/slice'
import firestoreReducer from './features/firestore/slice';
import tilesReducer from './features/firestore/tiles/slice'
import cellsReducer from './features/firestore/cells/slice'
import authReducer from './features/auth/slice'

// Tiles are persisted separately to IndexedDB (via localforage) because the
// 25k-tile dataset for a dense city (~5 MB) exceeds the localStorage quota.
// Cached tiles render immediately on page load; Firestore updates them in ~2 s.
const tilesPersistConfig = {
    key: 'tiles',
    storage: localforage,
    blacklist: ['isLoading'], // transient — always starts false
};

const rootReducer = combineReducers({
    location: locationReducer,
    map: mapReducer,
    firestore: firestoreReducer,
    tiles: persistReducer(tilesPersistConfig, tilesReducer),
    cells: cellsReducer,
    auth: authReducer,
});

export default rootReducer;
